//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import foretell from "@/mixins/foretell.js";
import { titleCase } from "~/src/titlecase";
import { clarityEvent } from "~/services/util";
import schemaHelpers from "~/mixins/schema-helpers.js";

var parseHeadlineText = function(headlineText) {
  if (!headlineText) return null;
  return titleCase(headlineText.replace(/-/g, " ").replace(/_/g, "-")).replace(
    /Llc/g,
    "LLC"
  );
};

export default {
  components: {},
  layout: "default-no-sticky",

  computed: {
    isDesignTestV3() {
      if (this.product.hero) return this.product.hero.table.design_test_v3;
    },
    product() {
      return this.$store.state.product.data;
    },
    hasError() {
      return this.$store.state.product.error;
    },
    isClient() {
      return process.client;
    },
    schemaFaqs() {
      if (
        this.product.page_body.find(
          (component) => component.table.type === "faqs"
        )
      )
        return this.product.page_body.find(
          (component) => component.table.type === "faqs"
        ).table.fields.table.faq;
    },
    schemaSteps() {
      if (
        this.product.page_body.find(
          (component) => component.table.type === "illustrated_steps"
        )
      )
        return this.product.page_body.find(
          (component) => component.table.type === "illustrated_steps"
        ).table.fields.table.steps;
    },
    meta() {
      if (this.product) {
        let metaInfo = {};
        if (
          this.product.meta_information &&
          this.product.meta_information.table.title
        ) {
          metaInfo.title = this.product.meta_information.table.title;
        } else if (this.product.meta_title)
          metaInfo.title = this.product.meta_title;
        if (
          this.product.meta_information &&
          this.product.meta_information.table.description
        ) {
          metaInfo.description = this.product.meta_information.table.description;
        } else if (this.product.meta_description)
          metaInfo.description = this.product.meta_description;
        if (
          this.product.meta_information &&
          this.product.meta_information.table.keyword
        ) {
          metaInfo.keyword = this.product.meta_information.table.keyword;
        } else if (this.product.meta_keyword)
          metaInfo.keyword = this.product.meta_keyword;
        if (
          this.product.meta_information &&
          this.product.meta_information.table.og_image
        ) {
          metaInfo.og_image = this.product.meta_information.table.og_image;
        }
        return metaInfo;
      }
    },
    showFormation() {
      return this.product.localeId == 1 && this.product.show_bf_ad;
    },
    createLink() {
      if (this.$route.query.form)
        if (this.product.order_type === "BusinessService")
          return `/orders/create/${this.product.slug}/${this.$route.query.form}`;
        else
          return `/documents/create/${this.product.slug}/${this.$route.query.form}`;
      else if (this.product.hero && this.product.hero.table.cta_link)
        return this.product.hero.table.cta_link;
      else if (this.product.order_type === "BusinessService")
        return `/orders/create/${this.product.slug}`;
      else {
        return `/documents/create/${this.product.slug}`;
      }
    },
  },
  watch: {
    hasError(error) {
      if (error) {
        location.href = "/categories";
      }
    },
    showPreview: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          document.body.classList.add("modal-active");
        } else if (newValue === false) {
          document.body.classList.remove("modal-active");
        }
      },
    },
  },
  mixins: [foretell, schemaHelpers],
  data() {
    return {
      showSticky: false,
      showVideo: false,
      showPreview: false,
      error: false,
      customText: "",
      isLoadedOnClient: true,
    };
  },
  head() {
    if (this.product && this.meta) {
      let domain;
      domain = "https://www.legalnature.com";
      let canonicalLink =
        domain +
        "/categories" +
        `/${this.product.categorySlug}` +
        `/${this.product.slug}`;
      let meta = [
        {
          name: "description",
          content: this.meta.description,
        },
        {
          name: "keyword",
          content: this.meta.keyword,
        },
        {
          name: "og:image",
          content: this.meta.og_image,
        },
      ];
      if (this.product.no_index) {
        meta.push({ name: "robots", content: "noindex" });
      }
      return {
        title: this.meta.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },
  jsonld() {
    if (!this.loading && !this.error) {
      const schemas = [];

      const articleSchema = {
        "@context": "https://schema.org",
        "@type": "Article",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": `https://www.legalnature.com/categories/${this.product.categorySlug}/${this.product.slug}`,
        },
        headline: this.meta.title,
        description: this.meta.description,
        image: {
          "@type": "ImageObject",
          url: this.meta.og_image || "https://www.legalnature.com/apple-touch-icon.png",
          width: "1200",
          height: "630",
        },
        keywords: this.meta.keyword,
        inLanguage: "en-US",
        author: this.schemaAuthor,
        publisher: {
          "@type": "Organization",
          name: "LegalNature",
          logo: {
            "@type": "ImageObject",
            url: "https://www.legalnature.com/apple-touch-icon.png",
          },
        },
        accessMode: "textual",
        accessModeSufficient: "textual",
        accessibilityAPI: "ARIA",
        isAccessibleForFree: true,
      };

      if (Array.isArray(this.schemaSteps) && this.schemaSteps.length > 0) {
        articleSchema.step = {
          "@type": "HowTo",
          name: "How to Create This Document",
          step: this.schemaSteps.map((step, index) => ({
            "@type": "HowToStep",
            position: index + 1,
            name: step.table.headline,
            text: step.table.description,
          })),
        };
      }

      schemas.push(articleSchema);

      if (Array.isArray(this.schemaFaqs) && this.schemaFaqs.length > 0) {
        const faqSchema = {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: this.schemaFaqs.map((faq) => ({
            "@type": "Question",
            name: faq.table.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: this.stripHtmlTags(faq.table.answer),
            },
          })),
        };
        schemas.push(faqSchema);
      }

      const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: this.product.product_name,
        description: this.meta.description,
        brand: {
          "@type": "Organization",
          name: "LegalNature LLC",
        },
        image: {
          "@type": "ImageObject",
          url: this.meta.og_image || "https://www.legalnature.com/apple-touch-icon.png",
          width: "1200",
          height: "630",
        },
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "4.3",
          reviewCount: "8879",
          bestRating: "5",
        },
      };

      const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.legalnature.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: this.slugToTitle(this.product.category_slug),
            item: `https://www.legalnature.com/categories/${this.product.categorySlug}`,
          },
          {
            "@type": "ListItem",
            position: 3,
            name: this.product.product_name,
            item: `https://www.legalnature.com/categories/${this.product.categorySlug}/${this.product.slug}`,
          },
        ],
      };

      schemas.push(productSchema, breadcrumbSchema);

      return schemas;
    }
    return null;
  },
  beforeRouteEnter(from, to, next) {
    next((vm) => {
      if (from.fullPath === "/categories/business-services/formation")
        vm.$router.replace("/business-formation");
    });
  },
  async fetch({ store, params, query, error, redirect }) {
    try {
      const preview = query.preview ? 1 : 0;
      let productSlug = params.product_slug.toLowerCase();
      await store.dispatch("product/getProduct", {
        productSlug: productSlug,
        options: { preview, type: "product_lander" },
        slugOverride: query.slug ? query.slug : null,
      });
      if (!store.state.product.data) {
        error({ statusCode: 404 });
      }
    } catch (e) {
      if (params.product_slug === "passport-service")
        redirect("/categories/personal-affairs/passport-application");
      else {
        console.error("category error", e);
        error({ statusCode: e });
      }
    }
  },
  async created() {
    if (process.client) {
      if (this.$route.query.hl) {
        // remove the custom headline.
        this.customText = parseHeadlineText(this.$route.query.hl);
      }
    }
  },
  async mounted() {
    if (process.client) {
      let landerMeta = {};
      let value = "product:" + this.$route.params.product_slug;
      landerMeta = {
        lander_test: value,
      };

      this.createOrLoadUserWithForetellEvent("lnd", landerMeta);
      window.addEventListener(
        "scroll",
        () => {
          if (this.$mq.resize) {
            if (this.$mq.above(this.$mv.md)) {
              this.showSticky = window.pageYOffset > 500;
            } else {
              this.showSticky = window.pageYOffset > 400;
            }
          }
        },
        { passive: true }
      );
      this.$nextTick(() => {
        // now that component is rendered, scroll to elem if elem.
        this.isLoadedOnClient = true;
        if (this.$route.hash) {
          const scrollRef = document.getElementById(
            this.$route.hash.replace(/\#/, "")
          );
          if (scrollRef) scrollRef.scrollIntoView();
        }
      });
    }
  },
  methods: {
    fieldsExists(field) {
      return field != null && field.length > 0;
    },
    stripHtmlTags(html) {
      return html.replace(/<\/?[^>]+(>|$)/g, "");
    },
    slugToTitle(slug) {
      const words = slug.split("-");
      return words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
};
